import React, { PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import classnames from 'classnames'

import { domOnlyProps } from 'utils/dom-only-props'

import styles from './text-input.css'

const TextInput = ({ data, faded, placeholder, disabled }) => (
  <input
    placeholder={placeholder}
    styleName={classnames('input', { 'input-faded': faded })}
    type="text"
    disabled={disabled}
    {...domOnlyProps(data)}
  />
)

TextInput.propTypes = {
  data: PropTypes.object.isRequired,
  faded: PropTypes.bool,
  placeholder: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
}

export default CSSModules(TextInput, styles, { allowMultiple: true })



/** WEBPACK FOOTER **
 ** ./src/components/setupform-form/field/text-input/text-input.js
 **/